import React from 'react';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import SendIcon from '@mui/icons-material/Send';
import ArticleIcon from '@mui/icons-material/Article';
import ExploreIcon from '@mui/icons-material/Explore';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'; // 公式リワード用のアイコン
import { Link } from 'react-router-dom';

// Dark theme settings
const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: '#2c5364',
      paper: '#2c5364',
    },
    primary: {
      main: '#2c5364',
    },
  },
});

// Apply styles to ListItemButton
const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: '8px',
  margin: '4px 8px',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    transform: 'scale(1.02)',
  },
  transition: 'transform 0.2s ease-in-out, background-color 0.2s ease-in-out',
}));

export default function NavigationMenu() {
  return (
    <ThemeProvider theme={darkTheme}>
      <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
        <ListItem disablePadding>
          <StyledListItemButton component={Link} to="/">
            <HomeIcon sx={{ mr: 2 }} />
            <ListItemText primary="Home" />
          </StyledListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <StyledListItemButton component={Link} to="/explore">
            <ExploreIcon sx={{ mr: 2 }} />
            <ListItemText primary="Explore" />
          </StyledListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <StyledListItemButton component={Link} to="/submit_form">
            <SendIcon sx={{ mr: 2 }} />
            <ListItemText primary="Submit Form" />
          </StyledListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <StyledListItemButton component={Link} to="/my-papers">
            <ArticleIcon sx={{ mr: 2 }} />
            <ListItemText primary="My Papers" />
          </StyledListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <StyledListItemButton component={Link} to="/whats-emcii">
            <HelpOutlineIcon sx={{ mr: 2 }} />
            <ListItemText primary="What's EMCII?" />
          </StyledListItemButton>
        </ListItem>
        <ListItem disablePadding>
          {/* Einstein AI is under development, so it is disabled */}
          <StyledListItemButton disabled>
            <SmartToyIcon sx={{ mr: 2 }} />
            <ListItemText primary="Einstein AI (Under Development)" />
          </StyledListItemButton>
        </ListItem>
        {/* officialrewards のメニュー項目を追加 */}
        <ListItem disablePadding>
          <StyledListItemButton component={Link} to="/official-rewards">
            <EmojiEventsIcon sx={{ mr: 2 }} />
            <ListItemText primary="Official Rewards" />
          </StyledListItemButton>
        </ListItem>
      </List>
    </ThemeProvider>
  );
}
